export const ShapeDividerBuilderID = '88110a9d-ba44-450e-bcf9-17058af00b76_3f4bd8f4-7124-4b69-a189-a03bd8ea7adf'
